"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../../styles/theme");

var KindurLogo_1 = __importDefault(require("../../../icons/KindurLogo"));

var Link = styled_1["default"]('a')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 1.125em;\n  font-weight: 500;\n  line-height: 2.1em;\n  margin: 0 1em;\n  text-decoration: none;\n\n  &:last-of-type {\n    margin-left: auto;\n  }\n\n  ", " {\n    margin: 0;\n    &:last-of-type {\n      margin-left: 0;\n    }\n  }\n"], ["\n  color: ", ";\n  font-size: 1.125em;\n  font-weight: 500;\n  line-height: 2.1em;\n  margin: 0 1em;\n  text-decoration: none;\n\n  &:last-of-type {\n    margin-left: auto;\n  }\n\n  ", " {\n    margin: 0;\n    &:last-of-type {\n      margin-left: 0;\n    }\n  }\n"])), theme_1.silvur.colors.mediumGray, theme_1.theme.breakpoints.tabletLandscapeDown);

function NavLinks(_a) {
  var track = _a.track,
      trackComponentName = _a.trackComponentName,
      setSidebarVisible = _a.setSidebarVisible;
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(Link, {
    title: 'Kindur',
    href: 'https://www.kindur.com/',
    target: '_top',
    onClick: function onClick() {
      track("Logo", trackComponentName);
      setSidebarVisible(false);
    }
  }, react_1["default"].createElement(KindurLogo_1["default"], {
    height: 28,
    alt: 'Kindur'
  })), react_1["default"].createElement(Link, {
    title: 'About',
    href: 'https://www.kindur.com/about',
    target: '_top',
    onClick: function onClick() {
      track("AboutUs", trackComponentName);
      setSidebarVisible(false);
    }
  }, "About Us"), react_1["default"].createElement(Link, {
    title: 'Kindur Login',
    href: 'https://app.kindur.com/login',
    target: '_blank',
    onClick: function onClick() {
      track("Login", trackComponentName);
    }
  }, "Kindur Login"));
}

exports["default"] = NavLinks;
var templateObject_1;